<div class="main-dialog">
  <button class="close-btn" type="button" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="text-part">
    <h2 class="text-part-title">{{ 'fee.end_billing_unpaid_title' | translate }}</h2>
    <p class="text-part-info">{{ 'fee.end_billing_unpaid_message' | translate }}</p>
  </div>

  <div class="action-part">
    <button class="option-notify option-shared" type="button" (click)="sendNotification()">
      {{ 'fee.send_notification' | translate }}
    </button>
    <button class="option-cancel option-shared" type="button" (click)="cancel()">{{ 'Cancel' | translate }}</button>
  </div>
</div>
